import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    Header: {
        display: "flex",
        alignItems: "center",
        marginBottom: "20px",

        "& .BackBtn": {
            border: "none",
            cursor: "pointer",
            background: "none",
            boxShadow: "none",
            marginRight: "14px",
        },
    },
    Details: {
        background: "#FFFFFF",
        border: "1px solid #e5e9f2",
        padding: "10px",
        display: "flex",
        alignItems: "center",
        width: "100%",

        "& .HeaderIcon": {
            width: "32px",
            height: "32px",
            background: "#e14954",
            borderRadius: "8px",
            marginRight: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
        },
        "& .HeaderTitle": {
            marginRight: "auto",
            "&>div:first-child": {
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: "12px",
                lineHeight: "15px",
                textTransform: "uppercase",
                color: "#271D1C",
                marginBottom: "5px",
            },
            "&>div:last-child": {
                fontWeight: "700",
                fontSize: "8px",
                lineHeight: "10px",
                textTransform: "uppercase",
                color: "rgba(39, 29, 28, 0.75)",
            },
        },
        "& .Actions": {
            color: "#6E7187",
            fontSize: "20px",
        },
    },
}));
